import { gsap } from "gsap";

export default class FormHandler {
	init() {
		// if (document.getElementById("form")) {
		// 	document.getElementById("form").addEventListener("submit", function (event) {
		// 		event.preventDefault();
		// 		
		// 		document.getElementById("response-message").classList.remove('hidden');
		// 		document.getElementById("response-message").innerHTML = `<p>Sending form, please wait...</p>`;
		// 
		// 		let formData = new FormData(this);
		// 
		// 		fetch("<?php echo admin_url('admin-post.php'); ?>", {
		// 			method: "POST",
		// 			body: formData,
		// 		})
		// 		.then(response => response.text())
		// 		.then(data => {
		// 			document.getElementById("form").classList.add('hidden');
		// 			document.getElementById("response-message").classList.remove('mt-vw-3');
		// 			document.getElementById("response-message").innerHTML = `<p>Thank you for getting in touch. A member of our team will get back to you as soon as possible.</p>`;
		// 		})
		// 		.catch(error => {
		// 			document.getElementById("response-message").innerHTML = `<p">There was an error. Please try again.</p>`;
		// 		});
		// 	});
		// }
		// function updateFileName(input) {
		// 	const label = document.getElementById("coverLetterLabel");
		// 	if (input.files.length > 0) {
		// 		label.textContent = input.files[0].name;
		// 	} else {
		// 		label.textContent = "Upload Cover Letter *"; // Reset if no file is chosen
		// 	}
		// }
		gsap.utils.toArray('.input-file').forEach((e) => {
			const input = e.querySelector('input');
			const label = e.querySelector('label');
			e.querySelector('input').addEventListener("change", function (event) {
				if (input.files.length > 0) {
					label.textContent = input.files[0].name;
				} else {
					label.textContent = label.innerHTML;
				}
			});
		});
	}
}